module.exports = __webpack_public_path__ + "img/symbol_9.9d26a1da.png";